import React from "react";
import { useSpring, animated } from '@react-spring/web';

const DynamicCount = ({ value }) => {
    const props = useSpring({
        number: value || 0,
        from: { number: 0 },
        config: { duration: 600 },
    });

    return (
        <animated.div>
            {props.number.to(n => Math.floor(n))}
        </animated.div>
    );
};

export default DynamicCount;
